module.exports = __webpack_public_path__ + "img/administrator.6fa0b6a7.png";